import { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Card, CardContent, CircularProgress, Container, Divider, TextField, Typography } from '@mui/material';
import { LoginJWT } from '../../components/authentication/login';
import { Link } from 'react-router-dom';
import LoginApi from 'src/api/LoginApi';
import { AccountResult } from 'src/types/accountResult';

const Login: FC<React.PropsWithChildren<unknown>> = () => {
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [passwordResetEmail, setPasswordResetEmail] = useState('');
  const [resetErrorMsg, setResetErrorMsg] = useState('');
  const [resetSuccessMsg, setResetSuccessMsg] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  const forgotPasswordClicked = () => {
    setShowResetPassword((prev) => !prev);
  };

  const resetPasswordClicked = async () => {
    try {
      setResetLoading(true);
      let result: AccountResult = await LoginApi.recoverPassword(passwordResetEmail);

      if (result.success) {
        setResetSuccessMsg(result.messages.join(' '));
      } else {
        setResetErrorMsg(result.errors.join(' '));
      }
    } catch (e) {
      setResetErrorMsg(e.message);
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <Helmet>
        <title>Login | Vendor Portal</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container maxWidth="sm" sx={{ py: '80px' }}>
          <Card>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3,
                }}
              >
                <div>
                  <Typography color="textPrimary" gutterBottom variant="h4">
                    Log in
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Please enter your BFG Username and password.
                  </Typography>
                </div>
                <Box sx={{ px: 2 }}>
                  <img alt="logo" src="/static/bfg_marketplace_expo_logo.svg" width="90px" />
                </Box>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                  mb: 2,
                }}
              >
                <LoginJWT />
              </Box>
              <Divider sx={{ my: 3 }} />
              <Box>
                <Link onClick={forgotPasswordClicked} to={''}>
                  Forgot Password?
                </Link>
                {showResetPassword && (
                  <div>
                    <TextField
                      sx={{ mb: 3, mt: 3 }}
                      id="userEmail"
                      label="Email"
                      variant="outlined"
                      value={passwordResetEmail}
                      onChange={(e) => setPasswordResetEmail(e.target.value)}
                    />
                    <br />
                    <Button color="primary" variant="contained" onClick={resetPasswordClicked}>
                      Reset Password
                    </Button>
                    {resetLoading && <CircularProgress />}
                    {resetErrorMsg && resetErrorMsg !== '' && (
                      <Typography color="error" variant="body2">
                        {resetErrorMsg}
                      </Typography>
                    )}
                    {resetSuccessMsg && resetSuccessMsg !== '' && (
                      <Typography color="success" variant="body2">
                        {resetSuccessMsg}
                      </Typography>
                    )}
                  </div>
                )}
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </div>
  );
};

export default Login;
